<template>
    <div>
        <v-dialog v-model="show" max-width="900" :fullscreen="phoneOnly" persistent scrollable transition="scroll-y-transition" overlay-color="#000" overlay-opacity="0.8" style="height: 100%">
            <v-card :class="{'fill-height': phoneOnly}">
                <div>
                    <v-toolbar flat style="border-bottom: 1px solid rgba(0,0,0, .1)!important">

                        <v-btn icon :color="currentDirectory ? 'teal darken-3' : 'text'" :disabled="!currentDirectory" @click="getDirContents({id: currentDirectory.parent_category_id})">
                            <v-icon>mdi-folder-move{{!currentDirectory ? '-outline' : ''}}</v-icon>
                        </v-btn>

                        <v-toolbar-title class="d-flex ps-0" style="font-size: 1.1rem">

                            <v-btn @click="getDirContents({id: null})" style="font-size: 1.1rem" text color="strong-text" dense class="px-2">
                                بنك اﻷسئلة
                            </v-btn>
                            <template v-if="currentDirectory" >

                                <template v-for="(dir) in currentDirectory.full_path_dirs">
                                    <v-icon size="20" :key="'icon' + dir.id" color="grey">mdi-chevron-left</v-icon>

                                    <v-btn @click="getDirContents(dir)" text color="strong-text" :key="'button' + dir.id" v-ripple="dir.id !== currentDirectory.id" dense style="text-transform: none; min-width: auto!important; font-size: 1.1rem" class="px-2 d-flex align-center">
                                        {{dir.name}}
                                    </v-btn>
                                </template>
                            </template>
                        </v-toolbar-title>
                        <!-- <div :class="{'strong-text--text': selectedQuestions.length, 'muted--text': !selectedQuestions.length}">{{selectedQuestions.length}} أسئلة محددة</div> -->

                        <v-spacer></v-spacer>

                        <!-- <v-btn icon>
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn> -->

                        <!-- <v-btn icon>
                            <v-icon>mdi-checkbox-multiple-marked</v-icon>
                        </v-btn> -->

                        <template v-if="selectedQuestions.length">
                            <v-btn large :disabled="adding" color="muted" text class="me-1" @click="show = false;">
                                إلغاء
                            </v-btn>
                            <v-btn large :loading="adding" color="primary" text class="px-5" @click="addQuestionsAction">
                                <span class="font-weight-bold">إضافة اﻷسئلة</span>
                            </v-btn>

                        </template>
                        <v-btn v-else icon @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-progress-linear v-show="loading" active indeterminate height="2" absolute bottom color="primary" ></v-progress-linear>
                    </v-toolbar>
                    <!-- <transition name="slide-y-transition"> -->
                    <v-toolbar height="50" flat color="grey lighten-5"> <!--  v-if="selectedQuestions.length" -->
                        <v-btn icon :color="currentSelectedAll ? 'primary' : 'text'" @click="toggleSelectAllCurrent" :disabled="!questionsItems || !questionsItems.length">
                            <v-icon>mdi-checkbox-{{currentSelectedAll ? 'marked' : (selectedQuestions.length ? 'intermediate' : 'blank-outline')}}</v-icon>
                        </v-btn>

                        <v-toolbar-title class="d-flex ps-0" style="font-size: 1rem" :class="{'strong-text--text': selectedQuestions.length, 'muted--text': !selectedQuestions.length}">{{selectedQuestions.length}} أسئلة محددة</v-toolbar-title>

                        <v-spacer></v-spacer>
                        <v-btn icon @click="resetSelections" color="error" :disabled="!selectedQuestions.length">
                            <v-icon>mdi-close-box-multiple</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <!-- </transition> -->
                </div>
                <v-card-text class="py-4" :class="{'px-0': phoneOnly}">

                    <div style="min-height: 85vh">
                        <div class="d-flex">
                        </div>
                        <div v-if="(directories && directories.length) || (questionsItems && questionsItems.length)">
                            <v-list v-if="directories && directories.length" two-line class="pa-0 mb-3">
                                <v-subheader style="height: auto">التصنيفات ({{directories.length}})</v-subheader>
                                <v-list-item v-for="dir in directories" :key="dir.id" v-ripple="phoneOnly" @click="getDirContents(dir)" :disabled="adding" class="directories-item">
                                    <v-list-item-icon>
                                        <v-icon color="blue darken-1">mdi-folder</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{dir.name}}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <div v-if="dir.child_categories_count || dir.questions_count" class="d-flex">
                                                <span v-if="dir.child_categories_count" class="me-3">
                                                    <v-icon class="me-1" size="14">mdi-folder-multiple-outline</v-icon>
                                                    <span>{{dir.child_categories_count}} مجلدات</span>
                                                </span>
                                                <span v-if="dir.questions_count">
                                                    <v-icon class="me-1" size="14">mdi-file-question-outline</v-icon>
                                                    <span>{{dir.questions_count}} أسئلة</span>
                                                </span>
                                            </div>
                                            <span v-else>مجلد فارغ</span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                    </v-list-item-icon>
                                </v-list-item>
                            </v-list>


                            <v-list v-if="questionsItems && questionsItems.length" two-line class="pa-0 mb-3">
                                <v-subheader style="height: auto">اﻷسئلة ({{questionsItems.length}})</v-subheader>
                                <v-list-item v-for="question in questionsItems" :key="question.id" :disabled="adding || examQuestionsArray.includes(question.id)" v-ripple="phoneOnly" @click="toggleSelect(question)" class="directories-item mb-1" :class="{'grey lighten-3': selectedQuestions.includes(question.id)}">
                                    <v-list-item-icon>
                                        <v-icon :color="examQuestionsArray.includes(question.id) ? 'grey' : 'strong-text'">mdi-file-question-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{question.name}}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <span v-if="examQuestionsArray.includes(question.id)">مضاف بالفعل</span>
                                            <span v-else>
                                                <v-chip color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                                    #{{question.id}}
                                                </v-chip>
                                                
                                                <question-difficulty :level="question.difficulty_level" class="me-1" />

                                                <v-chip v-if="question.answers.find(answer=>!!answer.correct)" color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                                    <span class="small-text me-1">الإجابة: </span>
                                                    <v-icon v-if="question.answers.find(answer=>!!answer.correct).image_url && !question.answers.find(answer=>!!answer.correct).text" small>mdi-image</v-icon>
                                                    <span v-else>{{textMax(question.answers.find(answer=>!!answer.correct).text, 40)}}</span>
                                                </v-chip>
                                            </span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                        <v-btn icon color="primary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="questionDetailsDialog = true; questionDetails = question;" :disabled="adding || examQuestionsArray.includes(question.id)">
                                            <v-icon size="22">mdi-file-eye-outline</v-icon>
                                        </v-btn>
                                        <v-btn v-if="selectedQuestions.length" icon :color="selectedQuestions.includes(question.id) ? 'primary' : 'text'" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="toggleSelect(question)" class="ms-2" :disabled="adding || examQuestionsArray.includes(question.id)">
                                            <v-icon size="25">mdi-checkbox-{{selectedQuestions.includes(question.id) ? 'marked' : 'blank-outline'}}</v-icon>
                                        </v-btn>
                                        <div v-else>
                                        </div>
                                    </v-list-item-icon>
                                </v-list-item>
                            </v-list>
                        </div>
                        <div v-else class="py-2">
                            <div v-if="loading" class="d-flex justify-center pa-3">
                                <v-progress-circular indeterminate transition="fade-transition" color="primary" size="40" width="3"></v-progress-circular>
                            </div>
                            <v-alert v-else text type="info" color="blue-grey darken-1" class="mb-0">
                                <b>التصنيف فارغ: </b> هذا التصنيف لا يحتوي على أي أسئلة أو تصنيفات فرعية
                            </v-alert>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <question-details v-model="questionDetailsDialog" :question-details="questionDetails" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import QuestionDetails from '@/components/custom/questions-details'
import QuestionDifficulty from '@/components/custom/question-difficulty'

export default {
    props: {
        value: {},
        exam: {},
        examQuestions: {},
    },
    components: {QuestionDetails, QuestionDifficulty},
    data(){
        return {
            adding: false,
            loading: false,
            false: false,
            show: false,
            selectedQuestions: [],

            currentDirectory: null,
            questionsItems: null,
            directories: null,

            questionDetailsDialog: false,
            questionDetails: null,
        }
    },
    computed: {
        ...GlobalComputed,
        examQuestionsArray(){
            return this.examQuestions.map(q=>q.id);
        },
        currentSelectedAll(){
            const questions = this.questionsItems;
            if(!questions || !questions.length){
                return false;
            }
            let selectedAll = true;
            questions.forEach(question => {
                if (!this.selectedQuestions.includes(question.id)){
                    selectedAll = false;
                }
            });
            return selectedAll;
        }

    },
    watch: {
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
            if (show){
                if (!this.directories){
                    this.getDirContents();
                }
            }
        },
    },
    methods: {
        addQuestionsAction(){
            if (!this.adding){
                this.adding = true;
                const data = {questions: this.selectedQuestions};
                this.$store.dispatch('fastPostAction', {url: `/exams/${this.exam.id}/questions`, data}).then(response=>{
                    this.showMsg('تم إضافة اﻷسئلة للامتحان بنجاح', 'success');
                    this.adding = false;
                    this.show = false;
                    this.$emit('sync', response.data.data);

                    window.setTimeout(()=>{
                        this.resetSelections();
                    }, 1000);

                }).catch(error=>{
                    this.adding = false;
                    this.showMsg('حدثت مشكلة أثناء اﻹضافة، حاول مرة ثانية', 'error');
                })
            }
        },
        resetSelections(){
            this.selectedQuestions = [];
        },
        toggleSelectAllCurrent(){
            if (!this.questionsItems){
                return;
            }

            if (this.currentSelectedAll){
                // remove all questions of current directory
                this.questionsItems.forEach(question => {
                    if (this.selectedQuestions.includes(question.id)){
                        this.selectedQuestions = this.selectedQuestions.filter(id=>id !== question.id);
                    }
                });
            }else{
                // add all questions of current directory
                this.questionsItems.forEach(question => {
                    if (!this.selectedQuestions.includes(question.id) && !this.examQuestionsArray.includes(question.id)){
                        this.selectedQuestions.push(question.id);
                    }
                });
            }
        },
        toggleSelect(question){
            if (this.selectedQuestions.includes(question.id)){
                this.selectedQuestions = this.selectedQuestions.filter(id=>id !== question.id);
            }else{
                this.selectedQuestions.push(question.id);
            }
        },
        getDirContents(dir=null){
            this.loading = true;
            if (!dir){
                dir = this.currentDirectory;
            }
            const url = `/exams/questions${dir && dir.id ? '/directories/' + dir.id : ''}`;
            this.$store.dispatch('fastGetAction', {url}).then(response=>{
                // set data
                const data = response.data;
                this.currentDirectory = data.current_directory ? data.current_directory : null;
                if (data.categories){
                    this.directories = data.categories.data;
                }else{
                    this.directories = [];
                }
                if (data.other_dir){
                    this.directories.push(data.other_dir);
                }
                if (data.questions){
                    this.questionsItems = data.questions.data;
                }else{
                    this.questionsItems = [];
                }

                this.loading = false;

            }).catch(e=>{
                this.showMsg('حدثت مشكلة أثناء تحميل المحتويات', 'error');
                console.error(e);
                this.loading = false;
            })
        },
        syncData(data){

        },
        textMax(text, length){
            return text ? (text.length > length ? text.slice(0, length) + ' ...' : text) : '';
        },
        ...GlobalMethods,
    },
    mounted(){

    }
}
</script>

<style lang="scss" scoped>
.v-list--two-line{
    .directories-item, .questions-item{
        &.v-list-item .v-list-item__icon{
            margin-bottom: 16px!important;
        }
    }
}
</style>
